import { render, staticRenderFns } from "./AiBudget.vue?vue&type=template&id=046f1c34"
import script from "./AiBudget.vue?vue&type=script&lang=js"
export * from "./AiBudget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports